import CalendarIcon from '@atlaskit/icon/core/calendar';
import * as React from 'react';

export function SvgCalendar() {
  return <CalendarIcon label="" testId="ads-refreshed-icon" />;
}
